import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface ITableHeaderProps {
  width: string;
}

export const TableHeader = styled.th<ITableHeaderProps>`
  position: relative;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 14px;
  font-weight: normal;
  text-align: left;
  text-transform: uppercase;
  vertical-align: middle;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.width
  };
`;

export const headerRowStyles = css`
  box-shadow:
    0 1px 4px 0 ${withVar(DesignToken.SurfaceTertiaryDefault)},
    inset 0 -1px 0 0 ${withVar(DesignToken.SurfaceTertiaryDefault)},
    inset 0 1px 0 0 ${withVar(DesignToken.SurfaceTertiaryDefault)};
`;

export const reportFieldStyles = css`
  cursor: pointer;
  padding: 8px 20px;
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  line-height: 1.33;
  vertical-align: middle;
  word-break: break-word;
  word-wrap: break-word;
`;

const highlight = keyframes`
  from {
    background-color: ${withVar(DesignToken.SurfaceAccentEmphasisLowInfo)};
  }

  to {
    background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  }
`;

export const rowHighlight = css`
  animation: ${highlight} 2s linear;
`;

export const textOverflowStyles = css`
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const width10Styles = css`
  width: 10%;
`;

export const width20Styles = css`
  width: 20%;
`;

export const width30Styles = css`
  width: 30%;
`;
